import moment from 'moment';
import { Base64 } from 'js-base64';

/**
 * 首屏优化 加载与执行
 * index内存在很多外部引用 导致index执行耗时（）
 * 实际上首页加载的时候不需要执行这么多
 * 后续方案 尽量加载和执行拆开(文件不直接执行 业务使用时在执行)
 *
 * 抽离index部分无依赖纯函数
 */
// 日期格式化
export const dateFormat = (date, formatString) => {
  var d = new Date(),
    str = 'yyyy-MM-dd';
  if (!date) return '';
  //date = date.trim();
  // 默认时间为当地0点
  if (/^\d{4}.\d{2}.\d{2}$/.test(date)) {
    date += ' 00:00';
  }

  // 仅传入时间时，日期默认为1970/01/01
  if (/^\d{2}.\d{2}$/.test(date)) {
    date = '1970/01/01 ' + date;
  }

  d = new Date(date);
  if (d.toString() === 'Invalid Date') {
    if (typeof date === 'string') {
      d = new Date(date.replace(/\-/gm, '/'));
      if (d.toString() === 'Invalid Date') {
        if (typeof date === 'string') {
          d = new Date(moment(date).format('YYYY-MM-DD'));
        }
      }
    }
  }
  if (!formatString) return d.Format(str);
  if (d.Format) {
    return d.Format(formatString);
  } else {
    let year = d.getFullYear(),
      month = d.getMonth() + 1,
      day = d.getDate(),
      hours = d.getHours(),
      minutes = d.getMinutes(),
      seconds = d.getSeconds();
    return (formatString = formatString
      .replace('yyyy', year)
      .replace('MM', numberHandler(month))
      .replace('dd', numberHandler(day))
      .replace('hh', numberHandler(hours))
      .replace('mm', numberHandler(minutes))
      .replace('ss', numberHandler(seconds)));
  }

  function numberHandler(num) {
    return num > 9 ? num : `0${num}`;
  }
};

export const getDateStamp = (date) => {
  return getDateInstance(date).getTime();
};

// 根据时间字符串获取时间对象
export function getDateInstance(date) {
  let dateObj = null;
  if (!date) {
    dateObj = new Date();
  } else {
    dateObj = new Date(date);
    if (dateObj.toString() === 'Invalid Date') {
      date = date.replace(/\-/gm, '/');
      dateObj = new Date(date);
      if (dateObj.toString() === 'Invalid Date') {
        return null;
      }
    }
  }
  return dateObj;
}

/**
 * 深拷贝方法，支持多个数据拷贝，多个数据拷贝时第一项必须为数组或对象类型
 * 第一项为对象则其余项也必须是对象，返回值为多个对象的结合
 * 第一项为数组，则将多个数组合并，不是数组的像直接加入数组中
 * @param source
 * @returns {*}
 */
export const deepClone = (...source) => {
  let result, type;
  if (source.length === 0) {
    result = {};
  } else {
    type = getType(source[0]);
  }
  if (type === 'array') {
    result = source.reduce((newArr, currentValue) => {
      if (getType(currentValue) !== 'array') {
        currentValue = [currentValue];
      }
      return newArr.concat(localDeepClone(currentValue));
    }, []);
  } else if (type === 'object') {
    result = {};
    source.forEach((obj) => {
      if (getType(obj) !== 'object') {
        throw new Error(`${obj} is not an Object.`);
      }
      let tempObj = {};
      Object.keys(obj).forEach((key) => {
        tempObj[key] = localDeepClone(obj[key]);
      });
      Object.assign(result, tempObj);
    });
  } else if (source.length > 1) {
    throw new Error(`${source[0]} is not an Object or array.`);
  } else {
    result = source[0];
  }

  return result;

  /**
   * 单个数据深拷贝方法
   * @param obj
   * @returns {*}
   */
  function localDeepClone(obj) {
    let type = getType(obj),
      result;

    if (type === 'array') {
      result = [];
      obj.forEach((val) => {
        result.push(deepClone(val));
      });
    } else if (type === 'object') {
      result = {};
      for (let key in obj) {
        result[key] = deepClone(obj[key]);
      }
    } else {
      result = obj;
    }
    return result;
  }
};
//
export function getType(obj) {
  let toString = Object.prototype.toString;
  let map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
}
// get请求时转换参数
export function revertGetParams(obj) {
  let paramsArray = [];
  for (let params in obj) {
    let type = getType(obj[params]);
    if (['string', 'number', 'boolean', 'date'].includes(type)) {
      paramsArray.push(`${params}=${obj[params]}`);
    } else {
      if (type === 'array' && obj[params].length > 0) {
        obj[params].forEach((item) => {
          paramsArray.push(`${params}=${item}`);
        });
      }
    }
  }
  return '?' + paramsArray.join('&');
}

/**
 * base64编码
 */
export const encodeBase64 = (val) => {
  return Base64.encode(val);
};
/**
 * base64解码
 */
export const decodeBase64 = (val) => {
  return Base64.decode(val);
};

export const moneyFormat = function (value, precision = 2) {
  if (!value) return (0).toFixed(precision);
  if (isNaN(value)) {
    return value;
  }
  return (+value).toFixed(precision).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};
